import React from 'react';
import { Link } from 'react-router-dom';
import type { FooterLogoConfig } from '../Footer.types';
import { cn } from '@/utils/className';

const FooterLogo: React.FC<FooterLogoConfig> = ({ src, alt, to = '/', className }) => {
    return (
        <Link to={to} className={cn('flex items-center', className)}>
            <img src={src} alt={alt} className="me-2" />
        </Link>
    );
};

export default FooterLogo;